const stats = [
  {
    label: "참조 화합물",
    value: "142",
    unit: "종",
    color: "blue" as const,
    description: "SmilesMatcher 참조 DB",
  },
  {
    label: "GCN 파라미터",
    value: "~12.8K",
    unit: "",
    color: "purple" as const,
    description: "KROVEX 모델 파라미터",
  },
  {
    label: "VP 학습 데이터",
    value: "3,132",
    unit: "건",
    color: "green" as const,
    description: "증기압 예측 학습셋",
  },
  {
    label: "Sol 학습 데이터",
    value: "8,789",
    unit: "건",
    color: "indigo" as const,
    description: "용해도 예측 학습셋",
  },
  {
    label: "RoMSH 어휘",
    value: "38",
    unit: "종",
    color: "indigo" as const,
    description: "SMILES 토큰 vocab",
  },
  {
    label: "RoMSH 모델 크기",
    value: "26",
    unit: "MB",
    color: "indigo" as const,
    description: "d_model 256, 체크포인트",
  },
  {
    label: "RoMSH 학습 데이터",
    value: "미공개",
    unit: "",
    color: "indigo" as const,
    description: "인하대 협력 예정",
  },
];

const colorMap = {
  blue: {
    bg: "bg-blue-50",
    border: "border-blue-200",
    dot: "bg-blue-500",
    text: "text-blue-900",
    sub: "text-blue-600",
  },
  purple: {
    bg: "bg-purple-50",
    border: "border-purple-200",
    dot: "bg-purple-500",
    text: "text-purple-900",
    sub: "text-purple-600",
  },
  green: {
    bg: "bg-green-50",
    border: "border-green-200",
    dot: "bg-green-500",
    text: "text-green-900",
    sub: "text-green-600",
  },
  indigo: {
    bg: "bg-indigo-50",
    border: "border-indigo-200",
    dot: "bg-indigo-500",
    text: "text-indigo-900",
    sub: "text-indigo-600",
  },
};

export default function ModelStatsBar() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4">
      {stats.map((stat) => {
        const colors = colorMap[stat.color];
        return (
          <div
            key={stat.label}
            className={`${colors.bg} rounded-lg shadow-sm border ${colors.border} p-4`}
          >
            <div className="flex items-center gap-2 mb-1">
              <div
                className={`w-2 h-2 ${colors.dot} rounded-full`}
              />
              <span className="text-sm font-medium text-gray-600">
                {stat.label}
              </span>
            </div>
            <p className={`text-2xl font-bold ${colors.text}`}>
              {stat.value}
              {stat.unit && (
                <span className="text-sm font-normal ml-1">{stat.unit}</span>
              )}
            </p>
            <p className={`text-xs ${colors.sub} mt-1`}>{stat.description}</p>
          </div>
        );
      })}
    </div>
  );
}
